module.exports = __webpack_public_path__ + "img/vergnano-tradition.437bfd57.jpg";